// ─── LINE のご案内メールの印（/line/ 配下の t=） ─────────────────────────────────────
// 印は 14 日有効の持ち主証明（設計書 31 03 §1-3）。lib/sentry/pii.ts の redactSecretsInUrl から呼ぶ。
// 🔴 正規表現にしない。以前の `\/line\/[^?…]*\?…t=` は `/line/` が出るたびに末尾まで `?` を探し直し、
//    `/line/` を繰り返す8万文字で1件約1秒・16万文字で約3.7秒止まった（2026-10-19 Codex SO 3回目）。
//    URL のかたまり（空白・引用符・`<>` まで）ごとに、`/line/` の後の最初の `?` から `#` までのクエリで t= を伏せる。
//    `?` より前に `#` があるもの（`/line/x#y?t=`）は以前と同じく伏せない。`?`・`#` の位置は前へしか進めない＝1回なめるだけ。
const LINE_PATH = '/line/'
const URL_CHUNK = /[^\s"'<>]+/g

/**
 * クエリの t= を全部伏せる（以前は最後の1つだけだった）。`&` の後ろに加え `?` の後ろも見る＝クエリの中に
 * もう1つ `/line/…?t=` が入った形（以前の正規表現は内側の `/line/` から照合し直して伏せていた）を漏らさない。
 */
function redactLineQuery(query: string, redacted: string): string {
  return query.replace(/(^|[&?])t=[^&]+/g, `$1t=${redacted}`)
}

function redactLineChunk(chunk: string, redacted: string): string {
  let out = ''
  let copied = 0
  let from = 0
  let question = -1
  let hash = -1
  for (;;) {
    const at = chunk.indexOf(LINE_PATH, from)
    if (at === -1) break
    const pathStart = at + LINE_PATH.length
    if (question < pathStart) question = chunk.indexOf('?', pathStart)
    if (question === -1) break
    if (hash !== -1 && hash < at) hash = -1
    if (hash === -1) hash = chunk.indexOf('#', at)
    if (hash !== -1 && hash < question) {
      from = hash + 1
      continue
    }
    const end = hash === -1 ? chunk.length : hash
    out +=
      chunk.slice(copied, question + 1) + redactLineQuery(chunk.slice(question + 1, end), redacted)
    copied = end
    from = end
  }
  return copied === 0 ? chunk : out + chunk.slice(copied)
}

/** 文字列の中の `/line/…?…t=<印>` の印を伏せる（URL 以外の自由文に混ざっていても拾う）。 */
export function redactLineMarks(value: string, redacted: string): string {
  if (!value.includes(LINE_PATH)) return value
  return value.replace(URL_CHUNK, (chunk) =>
    chunk.includes(LINE_PATH) ? redactLineChunk(chunk, redacted) : chunk
  )
}
